import * as common from './common.json';

export const ko = {
  common,
};
